import {
  PASSWORD_LOWECASE_VALIDATOR,
  PASSWORD_NUMBER_ONLY_VALIDATOR,
  PASSWORD_NUMBER_VALIDATOR,
  PASSWORD_SAME_LETTER_VALIDATOR,
  PASSWORD_SEQUENCE_LETTER_VALIDATOR,
  PASSWORD_SEQUENCE_NUMBER_VALIDATOR,
  PASSWORD_SPECIAL_CHARACTER_VALIDATOR,
  PASSWORD_UPPERCASE_VALIDATOR,
  PASSWORD_UPPERCASE_ONLY_VALIDATOR,
  PASSWORD_LOWERCASE_ONLY_VALIDATOR,
} from './regex'

const passwordStrengthColor = {
  UNSAFE: 'negative',
  WEAK: 'attention',
  SAFE: 'positive',
}

const isPasswordSafe = password => {
  let score = 0

  if (password.match(PASSWORD_UPPERCASE_VALIDATOR)) {
    score++
  }

  if (password.match(PASSWORD_LOWECASE_VALIDATOR)) {
    score++
  }

  if (password.match(PASSWORD_NUMBER_VALIDATOR)) {
    score++
  }

  if (password.match(PASSWORD_SPECIAL_CHARACTER_VALIDATOR)) {
    score++
  }

  return score >= 2
}

const validatePasswordStrength = async ({ password }) => {
  const strength = {
    text: null,
    color: null,
  }

  try {
    if (!password) {
      strength.text = 'Digite uma senha com 8 ou mais caracteres, com letras e números.'
      strength.color = passwordStrengthColor.UNSAFE

      return { strength, shouldValidateRemote: false }
    }

    if (password.length < 8) {
      strength.text = 'A senha deve ter 8 ou mais caracteres, com letras e números.'
      strength.color = passwordStrengthColor.UNSAFE

      return { strength, shouldValidateRemote: false }
    }

    if (password.length > 30) {
      strength.text =
        'Senha muito longa. Digite uma senha com menos de 30 caracteres, com letras e números.'
      strength.color = passwordStrengthColor.UNSAFE

      return { strength, shouldValidateRemote: false }
    }

    if (
      password.match(PASSWORD_SEQUENCE_LETTER_VALIDATOR) ||
      password.match(PASSWORD_SEQUENCE_NUMBER_VALIDATOR) ||
      password.match(PASSWORD_SAME_LETTER_VALIDATOR)
    ) {
      strength.text =
        'A senha não pode ter sequências de números ou letras (Ex.: 123 ou abc). Digite outra senha com 8 ou mais caracteres, com letras e números.'
      strength.color = passwordStrengthColor.UNSAFE

      return { strength, shouldValidateRemote: false }
    }

    if (
      password.match(PASSWORD_LOWERCASE_ONLY_VALIDATOR) ||
      password.match(PASSWORD_NUMBER_ONLY_VALIDATOR) ||
      password.match(PASSWORD_UPPERCASE_ONLY_VALIDATOR)
    ) {
      strength.text =
        'Senha pouco segura. Digite uma senha com 8 ou mais caracteres, com letras e números.'
      strength.color = passwordStrengthColor.WEAK

      return { strength, shouldValidateRemote: false }
    }

    if (isPasswordSafe(password)) {
      strength.text = 'Senha segura.'
      strength.color = passwordStrengthColor.SAFE

      return { strength, shouldValidateRemote: true }
    } else {
      strength.text =
        'Senha pouco segura. Digite uma senha com 8 ou mais caracteres, com letras e números.'
      strength.color = passwordStrengthColor.WEAK

      return { strength, shouldValidateRemote: false }
    }
  } catch (err) {
    return strength
  }
}

export { validatePasswordStrength }
